import "../css/Footer.css";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope, FaLinkedinIn, FaYoutube } from 'react-icons/fa'; 
import { Link } from "react-router-dom";

// URL para Talatona, Luanda (ajustada para um embed funcional)
const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3941.8763567115463!2d13.1818!3d-8.9172!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a51f38e55e00001%3A0x1234567890abcdef!2sTalatona%2C%20Luanda!5e0!3m2!1spt-PT!2sao!4v1710000000000!5m2!1spt-PT!2sao";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer text-white pt-5 pb-0" style={{ backgroundColor: "#2c2219" }}>
      <div className="container text-start">
        <div className="row">
          
          {/* Coluna 1: Sobre o Escritório */}
          <div className="col-lg-4 col-md-6 mb-4">
            <h5 className="text-uppercase fw-bold mb-4 border-bottom border-secondary pb-2" style={{ color: "#c5a47e" }}>
              Paul Rodney & Associados
            </h5>
            <p className="small opacity-75" style={{ textAlign: 'justify' }}>
              Escritório de advogados dedicado à excelência jurídica e à defesa dos interesses dos nossos clientes, com presença em Angola e Portugal.
            </p>
            <p className="mt-3 small">
              <FaMapMarkerAlt className="me-2" style={{ color: "#c5a47e" }} /> 
              <strong>Localização:</strong> Avenida Via A2, Talatona, Luanda – Angola
            </p>
          </div>

          {/* Coluna 2: Links Rápidos */}
          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="text-uppercase fw-bold mb-4 border-bottom border-secondary pb-2" style={{ color: "#c5a47e" }}>
              Links Rápidos
            </h5>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/sobre" className="text-white-50 text-decoration-none hover-gold">Sobre Nós</Link></li>
              <li className="mb-2"><Link to="/noticias" className="text-white-50 text-decoration-none hover-gold">Notícias</Link></li>
              <li className="mb-2"><Link to="/artigos" className="text-white-50 text-decoration-none hover-gold">Artigos</Link></li>
              <li className="mb-2"><Link to="/contactos" className="text-white-50 text-decoration-none hover-gold">Contactos</Link></li>
            </ul>
          </div>

          {/* Coluna 3: Fale Connosco */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="text-uppercase fw-bold mb-4 border-bottom border-secondary pb-2" style={{ color: "#c5a47e" }}>
              Fale Connosco
            </h5>
            <p className="mb-2 opacity-75"><FaPhone className="me-2" /> +244 940 069 666</p>
            <p className="mb-4 opacity-75"><FaEnvelope className="me-2" /> info@paul-rodney.com</p>
            
            <a href="tel:+244940069666" className="btn btn-outline-light rounded-0 p-2 px-4 btn-footer-custom">
               Agendar Consulta
            </a>
          </div>
          
          {/* Coluna 4: Redes Sociais */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="text-uppercase fw-bold mb-4 border-bottom border-secondary pb-2" style={{ color: "#c5a47e" }}>
              Siga-nos
            </h5>
            <div className="social-icons fs-5">
              <a href="#" className="text-white me-3 opacity-75 hover-gold"><FaFacebookF /></a>
              <a href="#" className="text-white me-3 opacity-75 hover-gold"><FaLinkedinIn /></a>
              <a href="#" className="text-white me-3 opacity-75 hover-gold"><FaInstagram /></a>
              <a href="https://wa.me/+244940069666" className="text-white me-3 opacity-75 hover-gold"><FaWhatsapp /></a>
            </div>
            <p className="mt-3 small opacity-75">
              Acompanhe as nossas atualizações e conteúdos jurídicos.
            </p>
          </div>
        </div>
      </div>

      {/* Mapa de Localização */}
      <div className="row m-0 p-0">
          <div className="col-12 p-0">
              <div className="overflow-hidden" style={{ height: '250px', width: '100%',  }}>
                  <iframe
                      title="Localização Paul Rodney"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      loading="lazy"
                      allowFullScreen
                      src={mapEmbedUrl}
                  ></iframe>
              </div>
          </div>
      </div>
      
      {/* Footer Bottom */}
      <div className="p-3 pt-4 small text-center fw-light" style={{ backgroundColor: "#1a1510", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div className="container opacity-50">
          © {currentYear} Paul Rodney & Associados. Todos os direitos reservados.
        </div>
      </div>

      <style>{`
        .hover-gold:hover {
          color: #c5a47e !important;
          transition: 0.3s;
        }
        .btn-footer-custom {
          border-color: #c5a47e;
          color: #c5a47e;
          font-size: 0.85rem;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        .btn-footer-custom:hover {
          background-color: #c5a47e;
          border-color: #c5a47e;
          color: #fff;
        }
      `}</style>
    </footer>
  );
};

export default Footer;